export default "__VITE_ASSET__DolXLFiV__"